// extracted by mini-css-extract-plugin
export default {"uploadArea":"UploadArea_uploadArea__3fBUp","dragOver":"UploadArea_dragOver__WmAxV","icon":"UploadArea_icon__paoFd"};